import React, { Component } from 'react';
import './CustomReportsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Divider from '../../components/divider/Divider';
import models from '../../model/models';
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import ReportsTabBar from "../../components/reportsTabBar/ReportsTabBar";
import ReportCard from "../../components/reportCard/ReportCard";

export default class CustomReportsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount = () => {
		this.subscribeId = models.report.onChange(this._getData);
	};

	componentWillUnmount = () => {
		models.report.unsubscribe(this.subscribeId);
	};

	_getData = () => {
		let reports = models.report.objs();
		this.setState({ reports });
	};

	_renderReports = () => {
		const displayReports = [];
		for (let i in this.state.reports) {
			const report = this.state.reports[i];
			displayReports.push(
				<ReportCard key={i} title={report.name} description={report.description} url={'/reports/custom/' + report.id} />
			);
		}
		return displayReports;
	};

	render() {
		return (
			<Page className="g-custom-reports-page">
				<UpdateTitle newTitle="Reports" originalTitle="LogRx" />
				<Card className="main">
					<ReportsTabBar/>
					<Divider />
					<div className="reports">{this._renderReports()}</div>
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/customReportsPage/CustomReportsPage.jsx